/** Only plain CSS colours (hex, rgb[a], hsl[a]) may reach a `style` attribute; anything else returns null and is never drawn. */
export const safeColor = (value: string): string | null =>
  /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%/]+\)|hsla?\([\d\s.,%/deg]+\))$/i.test(value.trim()) ? value.trim() : null;
